var stripeKey = process.env.VUE_APP_STRIPE_PUBLIC_KEY;

export default stripeKey;
